import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const adminToken = localStorage.getItem('cardapio_token');
  const customerToken = localStorage.getItem('customer_token');

  const isCustomerRoute = req.url.includes('/customer/');
  const isPublicOrder =
    req.method === 'POST' &&
    req.url.includes('/public/orders');

  let token: string | null = null;

  // Rotas do cliente e criação de pedidos usam o token do cliente
  if (isCustomerRoute || isPublicOrder) {
    token = customerToken;
  } else {
    // Demais rotas protegidas usam o token do admin
    token = adminToken;
  }

  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return next(authReq);
};